import { CONTRACT_SYMBOLS } from 'constants/actionTypes';
import { createLoadingSelector } from 'erisxkit/client';
import { useAppSelector } from 'hooks/useAppSelector';
import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import {
  contractSymbols,
  getFilteredContractSymbolOptions,
} from 'reducers/contractsReducer';
import {
  Dropdown,
  DropdownProps,
  Form,
  FormFieldProps,
  StrictDropdownProps,
} from 'semantic-ui-react';

type Props = { productSymbol?: string; name?: string } & FormFieldProps &
  StrictDropdownProps;

const ExchangeSymbolDropdown = ({
  productSymbol,
  label = 'Exchange Symbol',
  name = 'contractSymbol',
  placeholder = 'Select Exchange Symbol...',
  onChange,
  value,
}: Props) => {
  const dispatch = useDispatch();
  const loading = useAppSelector(createLoadingSelector([CONTRACT_SYMBOLS]));
  const options = useAppSelector(getFilteredContractSymbolOptions);

  const [internalValue, setInternalValue] = useState(value);

  useEffect(() => {
    if (productSymbol) {
      setInternalValue('');
      dispatch(
        contractSymbols({
          filter: [{ attr: 'product_symbol', value: productSymbol, op: 'eq' }],
        }),
      );
    }
  }, [dispatch, productSymbol, setInternalValue]);

  useEffect(() => {
    // If the dropdown was cleared
    if (value === '' && internalValue !== '') {
      setInternalValue('');
    }
  }, [value, internalValue]);

  return (
    <Form.Field
      label={label}
      name={name}
      id={name}
      placeholder={placeholder}
      control={Dropdown}
      options={options}
      loading={loading}
      disabled={loading}
      selection
      search
      clearable
      onChange={(
        event: React.SyntheticEvent<HTMLElement>,
        props: DropdownProps,
      ) => {
        setInternalValue(props?.value);
        if (onChange) {
          onChange(event, props);
        }
      }}
      value={internalValue}
    />
  );
};

export default ExchangeSymbolDropdown;
